// @flow

import PointLayer12Resource from 'esm-web-pro/api/resources/methods/PointLayer12';
import type { UUID } from 'esm-web-pro/types/common';

export default class SwitchResource extends PointLayer12Resource {
    basePath: string = 'networks/switches/';

    createPath: string = 'networks/pops/{parent}/switches/';

    objectPath: string = 'networks/switches/{ident}/';

    _getCreatePath = (popId) => (this.createPath
        .replace('{parent}', popId)
    );

    createSwitch(popId, query: Object): Promise<Object> {
        return this.client._request(
            `${this._getCreatePath(popId)}`,
            'POST', query,
        ).then((response) => response.data);
    }

    updateSwitch(popId: UUID, odfId: UUID, query: Object): Promise<Object> {
        return this.client._request(
            this._getObjectPath(odfId),
            'PUT', query,
        ).then((response) => response.data);
    }

    schema(id: string): Promise<Object> {
        return this.client._request(this._getCreatePath(id), 'OPTIONS').then((response) => response.data);
    }

    connectPorts(id: string, data: Object): Promise<Object> {
        return this.client._request(
            `${this._getObjectPath(id)}connect_ports/`,
            'POST', data,
        ).then((response) => response.data);
    }

    getODFsAndSwitches(uuid, query: Object): Promise<Object> {
        return this.client._request(`${this._getObjectPath(uuid)}get_odfs_and_switches`,
            'GET', query).then((response) => response.data);
    }
}
